export default "__VITE_ASSET__CKMJLEXo__"